module.exports = __webpack_public_path__ + "static/media/score_modifier.96bd99c8.svg";